import React, { useEffect, useState } from 'react';
import {
  Button, Table, TableBody, TableCell, TableHead, TableRow,
  Paper, Typography, Pagination, TextField, Select, MenuItem, FormControl, InputLabel, Box
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import buxferTransactions from '../services/buxfer.service';

export default function BuxferNotSyncedAccountsPage() {
  const { userName } = useParams();
  const navigate = useNavigate();

  const [accounts, setAccounts] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState('');
  const [isNotSynced, setIsNotSynced] = useState('all');
  const [exportFormat, setExportFormat] = useState('csv');

  const fetchData = async () => {
    setLoading(true);
    try {
      let filterValue = null;
      if (isNotSynced === 'true') filterValue = true;
      else if (isNotSynced === 'false') filterValue = false;
      // else keep as null for 'all'

      const res = await buxferTransactions.getNotSyncedAccountsByUser(
        userName,
        page,
        10,
        search,
        filterValue, // this can now be true / false / null
        'lastSynced',
        'DESC'
      );

      if (res.success) {
        setAccounts(res.result.accounts);
        setTotalPages(res.result.totalPages);
      }
    } catch (err) {
      console.error('Fetch error:', err);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchData();
  }, [userName, page]);

  const handleSearch = () => {
    setPage(1);
    fetchData();
  };

  const handlePageChange = (_, value) => {
    setPage(value);
  };

  return (
    <Paper sx={{ padding: 2 }}>
      <Button variant="outlined" onClick={() => navigate(-1)} sx={{ mb: 2 }}>
        Back
      </Button>
      <Typography variant="h6" gutterBottom>
        Not Synced Accounts for <b>{userName}</b>
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <TextField
          label="Search Account Name"
          size="small"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <FormControl size="small">
          <InputLabel>Not Synced</InputLabel>
          <Select
            value={isNotSynced}
            label="Not Synced"
            onChange={(e) => setIsNotSynced(e.target.value)}
          >
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="true">Yes</MenuItem>
            <MenuItem value="false">No</MenuItem>
          </Select>
        </FormControl>
        <Button variant="contained" onClick={handleSearch}>Search</Button>
      </Box>

      {loading ? (
        <Typography>Loading...</Typography>
      ) : (
        <>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Account Name</TableCell>
                <TableCell>Bank</TableCell>
                <TableCell>Balance</TableCell>
                <TableCell>Currency</TableCell>
                <TableCell>Last Synced</TableCell>
                <TableCell>Not Synced?</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {accounts.map((acc) => (
                <TableRow key={acc.id}>
                  <TableCell>{acc.name}</TableCell>
                  <TableCell>{acc.bank}</TableCell>
                  <TableCell>{acc.balance}</TableCell>
                  <TableCell>{acc.currency}</TableCell>
                  <TableCell>{acc.lastSynced ? new Date(acc.lastSynced).toLocaleString() : '—'}</TableCell>
                  <TableCell>
                    {acc.notSynced ? (
                      <span style={{ color: 'red', fontWeight: 'bold' }}>Yes</span>
                    ) : (
                      <span style={{ color: 'green' }}>No</span>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Pagination count={totalPages} page={page} onChange={handlePageChange} sx={{ mt: 2 }} />
          {!loading && (
            <Box sx={{ display: 'flex', flexDirection: 'row-reverse', mt: 2 }}>
              <Button
                variant="outlined"
                onClick={() =>
                  buxferTransactions.exportNotSyncedAccounts(
                    userName,
                    search,
                    isNotSynced === 'all' ? null : isNotSynced,
                    exportFormat
                  )
                }
              >
                Export
              </Button>
              <FormControl size="small">
                <InputLabel>Format</InputLabel>
                <Select
                  value={exportFormat}
                  label="Format"
                  onChange={(e) => setExportFormat(e.target.value)}
                  sx={{ minWidth: 100 }}
                >
                  <MenuItem value="csv">CSV</MenuItem>
                  <MenuItem value="xlsx">Excel</MenuItem>
                  <MenuItem value="pdf">PDF</MenuItem>
                </Select>
              </FormControl>
            </Box>
          )}

        </>
      )}
    </Paper>
  );
}
